import { matchPath } from '~shared/utils/matchPath';
import { getAppUrl, getSubdomainUrlStr } from '~utils/host';

export const routes = {
	index: '/',
	chats: {
		home: '/chats',
		dialog: (recipientId: string | number) => `/chats/${recipientId}`,
		sitemap: '/chats/sitemap.xml',
	},
	profile: {
		home: '/profile',
		slug: (slug: string | number) => `/profile/${slug}`,
		sitemap: '/profile/sitemap.xml',
	},
	// TODO: Maybe is able to change routes.explore.home: '/models'
	explore: {
		home: '/',
		models: '/characters',
		slug: (slug: string) => `/characters/${slug}`,
		sitemap: '/characters/sitemap.xml',
	},
	generate: {
		character: '/generate/character',
		images: '/generate/images',
		videos: '/generate/videos',
		sitemap: '/generate/sitemap.xml',
	},
	gallery: {
		home: '/gallery',
	},
	company: {
		about: '/about',
	},
	// service
	subscribe: {
		home: '/subscribe',
	},
	signin: {
		home: '/signin',
	},
	signup: {
		home: '/signup',
	},
	neurons: {
		home: '/neurons',
	},
	// legals
	terms: {
		home: '/terms',
		us: '/termsus',
	},
	privacy: {
		home: '/privacy',
		us: '/privacyus',
	},
	support: {
		home: '/support',
	},
	refund: {
		home: '/refund',
	},
	safety: {
		home: '/safety',
	},
	complaints: {
		home: '/complaints-policy',
	},
};

const appUrl = getAppUrl();
const creatorUrl = getSubdomainUrlStr('creator');

export const externalRoutes = {
	becomeAffiliate: `${appUrl}affiliate-program?_gl=1*13em0hd*_ga*OTQ4ODEyOTYxLjE3NDYwMTY0MTI.*_ga_6CSFHDT4QZ*MTc0NjAzMDI4OS4zLjAuMTc0NjAzMDI4OS4wLjAuMTUyMjc0Mzk3Nw..*_fplc*UUhsNEhBTEJ2RjEydDVvdWhVZlI4TWMlMkJYRHYyMGdoeU5lT3NIOFZKUiUyRkZFTGtITGxuYSUyQmQxSDJWcmh2Q2FqazhydjdjVFR0M0xZJTJGJTJCazNXUkNpaGhBTUkwdXFZZnJmQnl1UGtpWDd5VnVYY2J4NjdNb3M3dFREY21OTkZEQSUzRCUzRA`,
	creatorUrl: `${creatorUrl}?_gl=1*57pd7j*_ga*OTQ4ODEyOTYxLjE3NDYwMTY0MTI.*_ga_6CSFHDT4QZ*MTc0NjAyNDc1MC4yLjAuMTc0NjAyNDc1MC4wLjAuMTI4NTIwOTk3NQ..*_fplc*c2E3UGFNWFY4a2NwZFV0Rm8ycDFidGxpYmZqNUZyd0Y2NDlQaUlVM0lHd2tFTTg0ZFZpTlJ5bVRKeVRJeTdFZzdKSVVXN3BZdjl5cU1jWlQzOEFyZEVNcDBNWUI5ajR3ZXhZekN1QWFxc2ptUENlbEZhWENRbmM4bXpuVnhBJTNEJTNE`,
};

const forceNSFWRoutes = [
	routes.explore.models,
	routes.generate.images,
	routes.generate.videos,
	routes.generate.character,
];

export const getIsForcedNSFWRoute = (pathname: string) => {
	if (matchPath(`${routes.explore.slug(':slug')}`, pathname)) {
		return true;
	}

	return forceNSFWRoutes.includes(pathname);
};

const NSFWRoutesRedirects = {
	[routes.explore.models]: routes.index,
	[routes.generate.images]: routes.index,
	[routes.generate.videos]: routes.index,
	[routes.generate.character]: routes.index,
};

export const getNSFWRoutesRedirect = (pathname: string) => {
	if (matchPath(`${routes.explore.slug(':slug')}`, pathname)) {
		return routes.index;
	}

	return NSFWRoutesRedirects[pathname];
};
